import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { AuthService } from '../service/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private auth: AuthService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {

    return this.auth.isRequested(next.data.screenId).map(result => {
      if (!result) {
        if (next.data.isPortal) {
          this.locationAssign('/portal');
        } else {
          this.router.navigate(['/error', '401']);
        }
      }
      return result;
    });
  }

  locationAssign(url: string) {
    location.href = url;
  }
}
